export const getContributionApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/contributions${queryString ? `?${queryString}` : ''}`;
};
export const addContributionApi = (params) => {
    return `lease/${params?.leaseSlug}/contributions`;
};
export const updateContributionApi = (params) => {
    return `lease/${params?.leaseSlug}/contributions/${params?.slug}`;
};
export const deleteContributionApi = (params) => {
    return `lease/${params?.leaseSlug}/contributions`;
};

export const obligationfileUploadPostApi = (obligation_slug) => {
    return `/get-pre-signed-url/contribution/${obligation_slug}`;
};

export const obligationAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/contribution/${attachments_slug}`
}
